import { DateFormatEnum } from '@models/enums';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

export const formatDate = (date?: dayjs.ConfigType) =>
    dayjs(date).format(DateFormatEnum.YEAR_MONTH_DAY);
export const formatDateUtc = (date?: dayjs.ConfigType) =>
    dayjs(date).utc().format(DateFormatEnum.MONTH_DATE_YEAR);
export const formatDateTimeUtc = (date?: dayjs.ConfigType) =>
    dayjs(date).utc().format(DateFormatEnum.MONTH_DATE_YEAR_TIME);
export const formatDateUnixDot = (date: number) =>
    dayjs.unix(date).format(DateFormatEnum.DAY_MONTH_YEAR_DOT);
export const formatDayMonth = (date?: dayjs.ConfigType) =>
    dayjs(date).format(DateFormatEnum.DAY_MONTH);

export const isBetweenDate = (
    date?: dayjs.ConfigType,
    dateFrom?: dayjs.ConfigType,
    dateTo?: dayjs.ConfigType,
) => dayjs(date).isBetween(dayjs(dateFrom), dayjs(dateTo), 'year', '[]');

export const isBeforeDateHelper = (comparingDate?: dayjs.ConfigType) => (date?: dayjs.ConfigType) =>
    dayjs(date).isBefore(comparingDate);
